import { useState } from "react";
import { collectionGroups } from "@/mocks/positiveNews";

export default function CollectionsSection() {
  const [index, setIndex] = useState(0);
  const group = collectionGroups[index];

  return (
    <section id="collections" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-2 flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600">
              <span className="h-px w-6 bg-primary-400" />
              红料合集 · COLLECTION
            </p>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">口碑最好的红料，都在这里</h2>
          </div>

          {/* 分段控制 */}
          <div role="tablist" aria-label="红料合集专题切换" className="inline-flex w-full max-w-full gap-1 rounded-full bg-background-200/70 p-1 sm:w-auto">
            {collectionGroups.map((g, i) => (
              <button
                key={g.label}
                role="tab"
                aria-selected={index === i}
                onClick={() => setIndex(i)}
                className={`whitespace-nowrap cursor-pointer rounded-full px-3 py-1.5 text-sm transition-colors sm:px-4 ${
                  index === i ? "bg-primary-500 text-background-50" : "text-foreground-700 hover:text-foreground-950"
                }`}
              >
                {g.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          {group.items.map((item, i) => (
            <article
              key={item.title}
              className={`flex flex-col rounded-2xl border p-5 transition-colors ${
                i === 0 ? "border-primary-200 bg-primary-50" : "border-background-200 bg-background-50"
              }`}
            >
              <div className="flex items-center justify-between">
                <span
                  className={`font-heading flex h-10 w-10 items-center justify-center rounded-xl text-lg font-bold ${
                    i === 0 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                  }`}
                >
                  {String(i + 1).padStart(2, "0")}
                </span>
                {i === 0 && (
                  <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-accent-500 px-2.5 py-1 text-[11px] font-semibold text-foreground-950">
                    <i className="ri-fire-fill" />
                    热门
                  </span>
                )}
              </div>
              <h3 className="mt-4 flex-1 font-heading text-lg font-bold leading-snug text-foreground-950">{item.title}</h3>
              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-sm text-foreground-500">
                <span className="flex items-center gap-1.5">
                  <i className="ri-eye-line" />
                  {item.reads} 次阅读
                </span>
                <i className="ri-arrow-right-line text-primary-600" />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}